<script>
  import Show3D from "./components/show3D.svelte";
  import Loading from "./components/loading.svelte";
  import * as t3dApp from "./model/model";

  var i = 0;
  let supportFullscreen = !/iPhone/i.test(navigator.userAgent);

  document.onclick = function () {
    i++;
    setTimeout(function () {
      i = 0;
    }, 300);
    if (i > 1) {
      t3dApp.tweenCameraFuc("startCamera", "startTarget", "0.6");
      i = 0;
    }
  };

  var iFullscreen = false; //当前是否全屏状态

  function fullScreenFun() {
    var fullscreenEnabled =
      document.fullscreenEnabled ||
      document.mozFullScreenEnabled ||
      document.webkitFullscreenEnabled ||
      document.msFullscreenEnabled;

    if (fullscreenEnabled) {
      let de = document.documentElement;
      if (iFullscreen) {
        iFullscreen = !iFullscreen;
        //关闭全屏
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        }
      } else {
        iFullscreen = !iFullscreen;
        //打开全屏
        if (de.requestFullscreen) {
          de.requestFullscreen();
        } else if (de.mozRequestFullScreen) {
          de.mozRequestFullScreen();
        } else if (de.webkitRequestFullScreen) {
          de.webkitRequestFullScreen();
        }
      }
    } else {
      // alert("浏览器当前不能全屏");
    }
  }
</script>

<Loading />
<Show3D />

{#if supportFullscreen}
  <img
    id="fullScreen"
    class="fullScreenImg"
    src="./img/fullScreen.png"
    alt=""
    on:click={fullScreenFun}
  />
{/if}

<style>
  .fullScreenImg {
    width: 18px;
    height: 18px;
    position: fixed;
    bottom: 15px;
    right: 15px;
  }
</style>
